import React from "react";
// redux
import { useSelector } from "react-redux";
// nodejs library that concatenates classes
import classNames from "classnames";
//react components for routing our app without refresh
import { Link } from "react-router-dom";
// @material-ui/core components
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from "@material-ui/core/Typography";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// other
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/components.js";
import { formatDateTime } from "utils.js";

const useStyles = makeStyles(styles);

export default function FoundListPage() {
  const classes = useStyles();
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgCard
  );

  const foundItems = useSelector((state) => state.foundItems);

  return (
    <div>
      <Header
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 200,
          color: "white",
        }}
      />
      <Parallax small image={require("assets/img/bg4.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Found Items</h1>
                <h3 className={classes.subtitle}>
                  The list of found items posted by the users.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <GridContainer className={classes.container}>
          {foundItems.map((foundItem) => {
            return (
              <GridItem key={foundItem.id} xs={12} md={6}>
                <Link to={"/founditems/" + foundItem.id}>
                  <ListItem button alignItems="flex-start">
                    <ListItemAvatar>
                      <img
                        src={foundItem.imageId}
                        alt="..."
                        height="150"
                        width="150"
                        className={imageClasses}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      className="ml-3 my-4"
                      primary={foundItem.itemName}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {foundItem.description}
                          </Typography>
                          <br />
                          <br />
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {"Posted By: " + foundItem.username}
                          </Typography>
                          <br />
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {"Date found:  " +
                              formatDateTime(foundItem.foundTimestamp)}
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                </Link>
              </GridItem>
            );
          })}
        </GridContainer>
      </div>

      <Footer />
    </div>
  );
}
